export enum DataMapperMappingTypes {
	string = 'string',
	number = 'number',
	integer = 'integer',
	float = 'float',
	boolean = 'boolean',
	date = 'date',
	object = 'object',
	'string[]' = 'string[]',
	'integer[]' = 'integer[]',
	'float[]' = 'float[]',
	'boolean[]' = 'boolean[]',
	'date[]' = 'date[]',
	'object[]' = 'object[]',
}
